<template>
  <div class="bg" v-if="list.length > 0">
    <div class="top-bg">
      <div class="title flex-center">
        <img
          src="https://img.esenyun.com/images/20200523/991aff8bd75a4671ba639ce998cd09cb.png"
          style="width:20px; height: 20px; margin-right: 4px;"
        />
        {{ title }}
      </div>
      <div class="flex-center" style="justify-content:center;">
        <div class="sales-people">
          <div class="flex-center">
            <div class="num-bg flex-center" v-for="item in numArr" :key="item">
              {{ item }}
            </div>
            <div>
              人正在秒杀抢购
            </div>
          </div>
        </div>
      </div>
      <div class="subtitle">每个用户仅限领取 {{ limit }} 款产品秒杀券</div>
    </div>
    <!-- 秒杀券 -->
    <div
      class="scroll"
      scroll-x
      :style="{ height: list.length < 4 ? '110px' : '210px' }"
    >
      <div
        class="flex-center scroll-view-container"
        :style="{ height: list.length < 4 ? '110px' : '210px' }"
      >
        <div
          style="width: 168px;margin: 0 8px 8px 0;"
          :style="{
            width: list.length === 3 || list.length > 4 ? '158px' : '168px',
          }"
          v-for="item in list"
          :key="item.seckillId"
          @click="goTodetails(item)"
        >
          <card
            :cardData="item"
            :width="list.length === 3 || list.length > 4 ? '158px' : '168px'"
          ></card>
        </div>
        <div
          style="width: 8px;"
          :style="{ height: list.length < 4 ? '110px' : '210px' }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import card from '../flash-card/card'
export default {
  props: {
    activityId: {
      type: String,
      default: '',
    },
    num: {
      type: Number,
      default: 0,
    },
    shareId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    card,
  },
  data() {
    return {
      numArr: [],
      list: [],
      title: '',
      limit: 0,
    }
  },
  mounted() {
    this.getCardList()
    this.getSettings()
  },
  methods: {
    goTodetails(item) {
      // uni.navigateTo({
      //   url: `/flashSale/detail?seckillId=${item.seckillId}&activityId=${item.activityId}`,
      // })
      this.$router.push(
        `seckill?seckillId=${item.seckillId}&activityId=${item.activityId}&shareId=${this.shareId}`
      )
    },
    getPeopelNum() {
      const showNum = this.num + ''
      this.numArr = showNum.split('')
    },
    getSettings() {
      this.$http
        .get(`aoseckill/openapi/sales/seckill/special/info/${this.activityId}`)
        .then((res) => {
          this.title = res.data.title
          this.limit = res.data.limitNum
        })
    },
    // 获取kaquanlist
    getCardList() {
      this.$http
        .get(`aoseckill/openapi/user/seckill/list/${this.activityId}`)
        .then((res) => {
          if (!res.data) {
            return false
          }
          this.list = res.data
          this.getPeopelNum()
        })
    },
  },
}
</script>

<style lang="less" scoped>
.bg {
  background: linear-gradient(
    168.07deg,
    #e42a28 0%,
    rgba(245, 112, 70, 0.88) 50.66%,
    #e6332d 77.11%
  );
  .scroll-view-container {
    width: 100%;
    height: 210px;
    padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
  }
  .top-bg {
    height: 118px;
    background: url('https://img.esenyun.com/images/20200523/0aff7a45ffb44ce285cfdcfde3dda3d1.png')
      no-repeat;
    background-size: 100%;
  }
  .swiper-card {
    height: 300px;
    flex-wrap: wrap;
  }
  .title {
    padding-top: 12px;
    padding-left: 16px;
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
  }
  .subtitle {
    font-size: 10px;
    line-height: 12px;
    color: #ffeae9;
    margin-top: 4px;
    text-align: center;
  }
  .sales-people {
    font-weight: 600;
    font-size: 17px;
    line-height: 24px;
    padding: 6px 25px;
    color: #fff5db;
    border: 1px solid #f6c766;
    border-radius: 50px;
    background: linear-gradient(
      90deg,
      #f88c4f 0%,
      #e25a3f 59.05%,
      #d93036 100%
    );
    .num-bg {
      width: 20px;
      height: 20px;
      font-size: 16px;
      margin-right: 4px;
      justify-content: center;
      background: #d64e1c;
      border-radius: 1px;
    }
  }
  .scroll {
    width: 100%;
    overflow-x: auto;
  }
}
</style>
